@let ticket = data.ticket | toTicketTile: data.productDefinition.name;
<aw-dialog
  class="max-h-[80vh] w-full bg-white sm:w-[400px]"
  (onClose)="dialogRef.close()"
  [content]="removeTicketDialogContent"
  [footer]="footerContent"
  [data]="data"
  [title]="
    (ticket.name || data.name) +
    ' ' +
    (textStore.texts()
      | filterTexts: ERelationType.remove : EEntityType.generic
      | language)
  "
  [width]="'400px'">
  <ng-template #removeTicketDialogContent>
    <div>
      {{
        textStore.texts()
          | filterTexts
            : ERelationType.removeTicketFromCart
            : EEntityType.shoppingCart
          | language
      }}
    </div>
  </ng-template>
  <ng-template #footerContent>
    <div class="flex w-full flex-row items-center justify-between pt-4">
      <aw-button
        type="button"
        [style]="'primary-alt'"
        id="ticket-remove-from-cart-dialog-cancel"
        (click)="dialogRef.close()"
        (keydown.enter)="dialogRef.close()"
        >{{
          textStore.texts()
            | filterTexts: ERelationType.cancel : EEntityType.generic
            | language
        }}</aw-button
      >
      <aw-button
        type="button"
        id="ticket-remove-from-cart-dialog-submit"
        (click)="removeTicket()"
        (keydown.enter)="removeTicket()"
        >{{
          textStore.texts()
            | filterTexts: ERelationType.removeTicket : EEntityType.shoppingCart
            | language
        }}</aw-button
      >
    </div>
  </ng-template>
</aw-dialog>
